export class playVideoInit {
  constructor() {
    this.initLegacyVideos()
    this.initLazyVideos()
  }

  initLegacyVideos() {
    const playBtns = document.querySelectorAll(".play_btn:not(.lazy-video .play_btn)")
    const videos = document.querySelectorAll("video:not(.lazy-video video)")

    if (playBtns.length && videos.length) {
      playBtns.forEach((playBtn, index) => {
        let video = videos[index]
        if (playBtn.getAttribute("data-id")) {
          const videoById = document.getElementById(playBtn.getAttribute("data-id"))
          if (videoById) video = videoById
        }

        if (video) {
          playBtn.addEventListener("click", () => {
            if (video.paused) {
              video.play()
              video.muted = false
              video.controls = true
              playBtn.classList.add("hide_btn")
            } else {
              video.pause()
              playBtn.classList.remove("hide_btn")
            }
          })

          video.addEventListener("ended", () => {
            playBtn.classList.remove("hide_btn")
          })
        }
      })
    }
  }

  initLazyVideos() {
    const lazyWrappers = document.querySelectorAll(".lazy-video")

    if (lazyWrappers.length) {
      lazyWrappers.forEach((wrapper) => {
        const btn = wrapper.querySelector(".play_btn") || wrapper.querySelector("button")

        if (btn) {
          btn.addEventListener("click", (e) => {
            e.preventDefault()
            this.loadAndPlay(wrapper, btn)
          })
        }
      })
    }
  }

  loadAndPlay(wrapper, btn) {
    const data = wrapper.dataset
    let sources = []
    try {
      sources = JSON.parse(data.sources || "[]")
    } catch (e) {
      console.error("Error parsing video sources", e)
    }

    const video = document.createElement("video")

    if (wrapper.className) {
      video.className = wrapper.className.replace("lazy-video", "").trim()
    }

    video.style.width = "100%"
    video.style.height = "100%"
    video.style.objectFit = "cover"

    if (data.id) video.id = data.id
    if (data.width) video.width = data.width
    if (data.height) video.height = data.height
    if (data.poster) video.poster = data.poster

    video.autoplay = true
    video.controls = true
    video.playsInline = true
    video.muted = false

    if (data.attr) {
      const attrs = data.attr.split(" ")
      attrs.forEach((attr) => {
        if (attr) video.setAttribute(attr, "")
      })
    }

    const fixPath = (path) => {
      if (
        path.startsWith("./") ||
        path.startsWith("/") ||
        path.startsWith("http") ||
        path.startsWith("video/")
      ) {
        return path
      }
      return `./video/${path}`
    }

    if (sources.length) {
      sources.forEach((srcItem) => {
        const sourceTag = document.createElement("source")
        sourceTag.src = fixPath(srcItem.src)
        sourceTag.type = `video/${srcItem.type}`
        video.appendChild(sourceTag)
      })
    } else if (data.src) {
      const fixedSrc = fixPath(data.src)
      video.src = `${fixedSrc}.${data.format}`
    }

    btn.style.display = "none"
    const posterImg = wrapper.querySelector("img")
    if (posterImg) posterImg.remove()

    wrapper.innerHTML = ""
    wrapper.appendChild(video)

    video.load()
    video.play().catch((e) => console.log("Autoplay blocked:", e))
  }
}
